import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

export const settingsMultiplierSteps: DriveStep[] = [
    {
        element: `#${ONBOARDING_IDS.SETTINGS_NAV}`,
        popover: {
            title: "Settings Sections",
            description:
                "Switch between <b>Multiplier</b> settings to tune the KPI scoring weights, and <b>Report</b> settings to configure automated email reports.",
        },
    },
    {
        element: `#${ONBOARDING_IDS.SETTINGS_HEADER_BUTTONS}`,
        popover: {
            title: "Multiplier Controls",
            description:
                "<b>Refresh</b> discards unsaved edits. <b>Recalculate Database</b> re-runs all KPI calculations with the current weights (~45 seconds). <b>Save Changes</b> persists your edits — remember to recalculate afterward.",
        },
    },
    {
        element: `#${ONBOARDING_IDS.SETTINGS_LIST}`,
        popover: {
            title: "KPI Weights",
            description:
                "Each row is a stat category with its weight and max points. Toggle categories on or off and adjust values to shape how the overall player score is calculated.",
        },
    },
    {
        element: `#${ONBOARDING_IDS.SETTINGS_RESET_ALL}`,
        popover: {
            title: "Reset All to Default",
            description:
                "Restores every multiplier back to the original default values recommended by the app creators. This cannot be undone — but you can always adjust individual weights afterwards.",
        },
    },
];

